<p-sidebar [(visible)]="visible" position="right" [style]="{ width: '30rem' }" (onHide)="cerrar()">
    <ng-container *ngIf="nodoForm" [formGroup]="nodoForm">
        <h5>{{ titulo }}</h5>

        <p class="text-500 text-sm mt-0 mb-4" *ngIf="esInicial">
            Este paso son los botones de la plantilla. Las etiquetas salen de ahí y no se editan acá:
            solo hay que elegir a dónde lleva cada uno.
        </p>

        <div class="field" *ngIf="!esInicial">
            <label for="nodo-tipo">¿Qué hace este paso?</label>
            <p-dropdown
                id="nodo-tipo"
                formControlName="tipo"
                [options]="tiposDeNodo"
                (onChange)="onTipoChange()"
                styleClass="w-full"
                appendTo="body"
            ></p-dropdown>
            <small class="text-500 block mt-1">{{ ayudaDelTipo }}</small>
        </div>

        <div class="field">
            <label for="nodo-texto">{{ etiquetaTexto }}</label>
            <textarea
                id="nodo-texto"
                pInputTextarea
                formControlName="texto"
                rows="4"
                class="w-full"
                [maxlength]="limites.BODY_MAX_CARACTERES"
            ></textarea>
            <small class="text-500 block mt-1" *ngIf="ayudaTexto">{{ ayudaTexto }}</small>
            <small class="p-error block" *ngIf="nodoForm.get('texto')?.invalid && nodoForm.get('texto')?.touched">
                Este texto es obligatorio (máximo {{ limites.BODY_MAX_CARACTERES }} caracteres).
            </small>
        </div>

        <div class="field" *ngIf="esMessage">
            <label for="nodo-siguiente">¿Con qué paso sigue después de este mensaje?</label>
            <p-dropdown
                id="nodo-siguiente"
                formControlName="siguienteNodoId"
                [options]="nodosDisponibles"
                optionLabel="label"
                optionValue="id"
                [showClear]="true"
                placeholder="Elegí un paso de la lista"
                styleClass="w-full"
                appendTo="body"
            ></p-dropdown>
            <small class="text-500 block mt-1">
                Si lo dejás vacío, la conversación pasa a la bandeja para que la siga una persona.
            </small>
        </div>

        <div *ngIf="esChoice" formArrayName="opciones">
            <div class="flex justify-content-between align-items-center mb-2">
                <h6 class="m-0">{{ esInicial ? 'Botones de la plantilla' : 'Botones de este paso' }}</h6>
                <button
                    *ngIf="!esInicial"
                    pButton
                    type="button"
                    icon="pi pi-plus"
                    label="Agregar botón"
                    class="p-button-text p-button-sm"
                    [disabled]="!puedeAgregarBoton"
                    [pTooltip]="puedeAgregarBoton ? '' : 'Meta permite hasta ' + limites.BOTONES_MAX_REPLY + ' botones'"
                    (click)="agregarOpcion()"
                ></button>
            </div>

            <div *ngFor="let opcionForm of opciones?.controls; let i = index" [formGroupName]="i" class="opcion-card p-3 mb-2 border-1 border-round surface-border">

                <div class="field" *ngIf="esInicial">
                    <label>Botón</label>
                    <p class="m-0 font-semibold">{{ opcionForm.get('etiqueta')?.value }}</p>
                </div>

                <div class="field" *ngIf="!esInicial">
                    <label>Texto del botón</label>
                    <input
                        pInputText
                        type="text"
                        formControlName="etiqueta"
                        class="w-full"
                        [maxlength]="limites.BOTON_ETIQUETA_MAX_CARACTERES"
                        (input)="onEtiquetaOpcionChange(i)"
                    />
                    <small class="text-500">{{ opcionForm.get('etiqueta')?.value?.length || 0 }}/{{ limites.BOTON_ETIQUETA_MAX_CARACTERES }} — es lo que ve el cliente en el botón</small>
                    <small class="p-error block" *ngIf="opcionForm.get('etiqueta')?.invalid && opcionForm.get('etiqueta')?.touched">
                        El botón necesita un texto.
                    </small>
                </div>

                <div class="field">
                    <label>Si toca este botón, ¿a qué paso va?</label>
                    <p-dropdown
                        formControlName="destinoNodoId"
                        [options]="nodosDisponibles"
                        optionLabel="label"
                        optionValue="id"
                        placeholder="Elegí un paso de la lista"
                        styleClass="w-full"
                        appendTo="body"
                    ></p-dropdown>
                    <small class="p-error block" *ngIf="opcionForm.get('destinoNodoId')?.invalid && opcionForm.get('destinoNodoId')?.touched">
                        Todo botón tiene que llevar a algún paso. Si todavía no lo creaste, cerrá este panel y usá "Agregar paso".
                    </small>
                </div>

                <button
                    *ngIf="!esInicial"
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    label="Quitar botón"
                    class="p-button-text p-button-danger p-button-sm"
                    (click)="quitarOpcion(i)"
                ></button>
            </div>

            <small *ngIf="!opciones?.length" class="text-500">
                Este paso todavía no tiene botones. Agregá al menos uno.
            </small>
        </div>

        <div class="flex justify-content-end mt-4">
            <button pButton type="button" label="Listo" class="p-button-text" (click)="cerrar()"></button>
        </div>
    </ng-container>
</p-sidebar>
